import { render, staticRenderFns } from "./environmentalReportProofAction.vue?vue&type=template&id=dd35dce6"
import script from "./environmentalReportProofAction.vue?vue&type=script&lang=js"
export * from "./environmentalReportProofAction.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports